webpackJsonp([6,1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49);
	module.exports = __webpack_require__(361);


/***/ }),

/***/ 389:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(343);
	
	__webpack_require__(389);
	
	var _utils = __webpack_require__(48);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _navClick = __webpack_require__(139);
	
	var _navClick2 = _interopRequireDefault(_navClick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	$(document).ready(function () {
	    // Boom.init('#blog');
	    setTimeout(function () {
	
	        if (window.matchMedia("(min-width: 769px)").matches) {
	            var $rel = $(".blog_related");
	            $(".product_ncp").sticky({
	                topSpacing: $('.header-nav').outerHeight(false) + 15,
	                bottomSpacing: ($rel.length ? $rel.outerHeight(true) : 0) + $('.footer_wrap').outerHeight(true) + 80 + 15
	            });
	        }
	    });
	    $(".blog-wrap").on('click', ".blog_tile .thumb-wrap,.blog_tile .ghost_button", _navClick2.default.boom);
	
	    function pushHistory(url, title) {
	        try {
	            if (url == window.location.href) {
	                //the same
	                return;
	            }
	            window.history.pushState({ url: window.location.href }, title, url);
	            if (typeof title != "undefined") {
	                document.title = title;
	            }
	        } catch (e) {
	            console.error("[exception] pushstate");
	        }
	    }
	
	    $(".sort_link").click(function (ev) {
	        var $blog = $('#blog'),
	            el = ev.currentTarget,
	            $el = $(el),
	            url = el.href;
	        if ($el.hasClass('active')) {
	            ev.preventDefault();
	            ev.stopPropagation();
	            return;
	        }
	        $('.sort_link.active').removeClass('active');
	        $el.addClass('active');
	        _utils2.default.putSpinnerOn($(".blog-wrap"));
	        pushHistory(url);
	        $("html,body").animate({ scrollTop: $('.posts_sort').offset().top - $('.header-nav').outerHeight(true) }, 500);
	        _utils2.default.fetchJson(url + '&ajax=yes').then(function (json) {
	            $blog.replaceWith(json.fragments['#blog']);
	            _utils2.default.disableSpinner(300);
	            FB.XFBML.parse();
	        });
	        ev.preventDefault();
	        ev.stopPropagation();
	        return false;
	    });
	    $('form.search').on('submit', function (ev) {
	        var formEl = ev.currentTarget;
	        _utils2.default.putSpinnerOn($(".blog-wrap"));
	        _utils2.default.fetchJson(formEl.getAttribute('action'), new FormData(formEl), "POST").then(function (json) {
	            $("#blog").replaceWith(json.fragments['#blog']);
	            _utils2.default.disableSpinner(300);
	            FB.XFBML.parse();
	        });
	        ev.preventDefault();
	        ev.stopPropagation();
	    });
	});

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _animejs = __webpack_require__(136);
	
	var _animejs2 = _interopRequireDefault(_animejs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canvas = void 0;
	var ctx = void 0;
	var distance = 100;
	var numberOfParticules = 24;
	var animations = void 0;
	var x = void 0,
	    y = void 0;
	var colors = [
	// '#FF324A',
	// '#31FFA6',
	// '#206EFF',
	// '#FFFF99',
	
	// '#067331',
	'#afd66b', '#afd66b', '#ffa735', '#dd0000'];
	var noop = function noop() {};
	var boom = function boom(ev) {
		var w = canvas.offsetWidth,
		    h = canvas.offsetHeight;
		x = ev.clientX || ev.touches[0].clientX;
		y = ev.clientY || ev.touches[0].clientY;
		// x -= canvas.getBoundingClientRect().left;
		// y -= canvas.getBoundingClientRect().top;
		// x = canvas.width / 2;
		// y = canvas.height / 2;
	
		canvas.style.left = x + 'px';
		canvas.style.top = y - h * 0.5 + 'px';
		canvas.render();
		x = w * 0.5;
		y = h * 0.5;
		animateParticles(x, y);
		canvas.classList.add('active');
	};
	var getFontSize = function getFontSize() {
		return 0.4 * parseFloat(getComputedStyle(document.documentElement).fontSize);
	};
	var setCanvasSize = function setCanvasSize() {
		var size = 500;
		canvas.width = size; //window.innerWidth;
		canvas.height = size; //window.innerHeight;
	};
	var createParticule = function createParticule(x, y) {
		var p = {};
		p.x = x;
		p.y = y;
		p.color = colors[_animejs2.default.random(0, colors.length - 1)];
		p.radius = _animejs2.default.random(getFontSize(), getFontSize() * 2);
		p.draw = function () {
			ctx.beginPath();
			ctx.arc(p.x, p.y, p.radius, 0, 2 * Math.PI, true);
			ctx.fillStyle = p.color;
			ctx.fill();
		};
		return p;
	};
	
	var createParticles = function createParticles(x, y) {
		var particules = [];
		for (var i = 0; i < numberOfParticules; i++) {
			var p = createParticule(x, y);
			particules.push(p);
		}
		return particules;
	};
	var animateParticles = function animateParticles(x, y) {
		setCanvasSize();
		var particules = createParticles(x, y);
		var particulesAnimation = (0, _animejs2.default)({
			targets: particules,
			x: function x(p) {
				return p.x + _animejs2.default.random(-distance, distance);
			},
			y: function y(p) {
				return p.y + _animejs2.default.random(-distance, distance);
			},
			radius: 0,
			duration: function duration() {
				return _animejs2.default.random(1200, 1800);
			},
			easing: 'easeOutExpo',
			complete: removeAnimation
		});
		animations.push(particulesAnimation);
	};
	var removeAnimation = function removeAnimation(animation) {
		var index = animations.indexOf(animation);
		if (index > -1) animations.splice(index, 1);
		if (animations.length == 0) {
			canvas.classList.remove('active');
		}
	};
	
	var init = function init(canvasSelector) {
		document.addEventListener('DOMContentLoaded', function () {
			if (!canvasSelector) {
				canvas = document.createElement('canvas');
				document.body.appendChild(canvas);
			} else {
				canvas = document.querySelector(canvasSelector);
			}
			canvas.addEventListener('click', boom);
			setCanvasSize();
			canvas.classList.add('boom');
			ctx = canvas.getContext('2d');
			x = 0;
			y = 0;
			animations = [];
	
			var mainLoop = (0, _animejs2.default)({
				duration: Infinity,
				update: function update() {
					ctx.clearRect(0, 0, canvas.width, canvas.height);
					animations.forEach(function (anim) {
						anim.animatables.forEach(function (animatable) {
							animatable.target.draw();
						});
					});
				}
			});
		}, false);
	};
	
	exports.default = {
		boom: window.enable_frontend_boom_effect ? boom : noop,
		init: window.enable_frontend_boom_effect ? init : noop
	};

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var spinnerTimeout = null,
	    opacityTimeout = null;
	var loadedScripts = [];
	var spinnerStartTime = 0;
	/**
	 * Remove by value
	 * @returns {Array}
	 */
	Array.prototype.remove = function () {
	    var what = void 0,
	        a = arguments,
	        L = a.length,
	        ax = void 0;
	    while (L && this.length) {
	        what = a[--L];
	        while ((ax = this.indexOf(what)) !== -1) {
	            this.splice(ax, 1);
	        }
	    }
	    return this;
	};
	if (window.Element) {
	    Element.prototype.render = function () {
	        "use strict";
	
	        this.offsetHeight;
	        return this;
	    };
	}
	
	function _doDisableSpinner() {
	    var $spin = $(".cart_item_loader");
	    if (!$spin) {
	        return;
	    }
	    $spin.css({ "opacity": 0 })[0].render();
	    spinnerTimeout = setTimeout(function () {
	        spinnerTimeout = null;
	        $spin.hide();
	    }, 400);
	}
	var Utils = {
	    fetchJson: function fetchJson(url, query, method) {
	        if (method === undefined) {
	            method = "GET";
	        }
	        var conf = { method: method, credentials: 'same-origin' };
	        if (method == "POST") {
	            if (query instanceof FormData) {
	                conf.body = query;
	            } else {
	
	                var data = new FormData();
	                Object.keys(query).map(function (k) {
	                    return "" + data.append(k, query[k]);
	                });
	                conf.body = data;
	            }
	        } else {
	            if (query && method == "GET") {
	                url += '?' + Object.keys(query).map(function (k) {
	                    return encodeURIComponent(k) + "=" + encodeURIComponent(query[k]);
	                }).join('&');
	            }
	        }
	        return fetch(url, conf).then(function (response) {
	            if (response.status >= 200 && response.status < 300) {
	                return response;
	            } else {
	                var error = new Error(response.statusText);
	                error.response = response;
	                throw error;
	            }
	        }).then(function (promise) {
	            var json = promise.json();
	            if (json['error'] !== undefined) {
	                alert("Promise failed: " + json['error']);
	            }
	            return json;
	        });
	    },
	    dietCases: function dietCases(more) {
	        var number = '';
	        if (more == 1) {
	            number = 'dzień diety';
	        } else if (more >= 5) {
	            number = 'dni diety';
	        } else {
	            number = 'dni diety';
	        }
	        return more + ' ' + number;
	    },
	    processValidationError: function processValidationError(id, $el, msg) {
	
	        if (msg != null) {
	            if ($el.parent().find(".checkout_errors").length == 0) {
	                $el.parent().append("<div class='checkout_errors checkout_errors_" + id + "'>" + msg + "</div>");
	            } else {
	                $el.parent().find(".checkout_errors").html(msg);
	            }
	            $el.parent().addClass("woocommerce-invalid woocommerce-invalid-required-field").removeClass("woocommerce-validated");
	            return 1;
	        } else {
	            $el.parent().find(".checkout_errors").text('');
	            $el.parent().removeClass("woocommerce-invalid woocommerce-invalid-required-field");
	            return 0;
	        }
	    },
	    maskZipCode: function maskZipCode(id) {
	        var selector = document.getElementById(id);
	        var im = new Inputmask("99-999");
	        im.mask(selector);
	        $("#" + id).blur(function (ev) {
	            var that = this;
	            ev.stopPropagation();
	            setTimeout(function () {
	                if (Inputmask.isValid($(that).val(), { alias: '99-999' })) {
	                    $("#" + id + "_field").addClass("woocommerce-validated");
	                } else {
	                    $("#" + id + "_field").removeClass("woocommerce-validated").addClass("woocommerce-invalid").addClass("woocommerce-invalid-required-field");
	                }
	            }, 100);
	        });
	    },
	    is_phone: function is_phone(phone) {
	        return !(0 < phone.replace(/[\s\#0-9_\-\+\(\)]/g, '').trim().length);
	    },
	    is_postcode: function is_postcode(postcode /*country: poland*/) {
	        return !(postcode.replace(/[\s\-A-Za-z0-9]/g, '').trim().length > 0);
	    },
	
	    // NIP validation, taken from:
	    // http://blog.aleksander.kaweczynski.pl/walidacja-numerow-pesel-nip-regon-w-javascript-i-php/
	    validate_nip: function validate_nip(nip) {
	        var nip_bez_kresek = nip.replace(/-/g, "");
	        var reg = /^[0-9]{10}$/;
	        if (reg.test(nip_bez_kresek) == false) {
	            return false;
	        } else {
	            var dig = ("" + nip_bez_kresek).split("");
	            var kontrola = (6 * parseInt(dig[0]) + 5 * parseInt(dig[1]) + 7 * parseInt(dig[2]) + 2 * parseInt(dig[3]) + 3 * parseInt(dig[4]) + 4 * parseInt(dig[5]) + 5 * parseInt(dig[6]) + 6 * parseInt(dig[7]) + 7 * parseInt(dig[8])) % 11;
	            return parseInt(dig[9]) == kontrola;
	        }
	    },
	    elementInViewport: function elementInViewport(el, offsetTop) {
	        if (el instanceof jQuery) {
	            el = el[0];
	        }
	        var top = el.offsetTop;
	        var left = el.offsetLeft;
	        var width = el.offsetWidth;
	        var height = el.offsetHeight;
	
	        while (el.offsetParent) {
	            el = el.offsetParent;
	            top += el.offsetTop;
	            left += el.offsetLeft;
	        }
	        top -= offsetTop;
	        return top >= window.pageYOffset && left >= window.pageXOffset && top + height <= window.pageYOffset + window.innerHeight && left + width <= window.pageXOffset + window.innerWidth;
	    },
	    putSpinnerOn: function putSpinnerOn(el, isFixed) {
	        if (typeof el == 'string') {
	            el = $(el);
	        }
	        if (el === undefined) {
	            isFixed = true;
	            el = $("body");
	        }
	        clearTimeout(opacityTimeout);
	        clearTimeout(spinnerTimeout);
	        var $el = $(el);
	        var off = $el.offset();
	        var $spin = $(".cart_item_loader");
	        if (!$spin) {
	            return;
	        }
	        $spin.css({
	            display: "flex",
	            // display: "block",
	            left: off.left + "px",
	            top: off.top + "px",
	            width: $el.outerWidth() + "px",
	            height: $el.outerHeight() + "px",
	            opacity: 0,
	            position: isFixed ? 'fixed' : 'absolute'
	        });
	        $spin[0].render();
	        $spin.css({ opacity: 1 });
	        spinnerStartTime = Date.now();
	    },
	
	    /**
	     * If minTimeout is object as {min:INTEGER}, it checks how long spinner has been running. If less than INTEGER, it sets timeout
	     * @param minTimeout
	     * @param afterTimeout
	     */
	    disableSpinner: function disableSpinner(timeout, afterTimeout) {
	        if ((typeof timeout === "undefined" ? "undefined" : _typeof(timeout)) == "object") {
	            timeout = timeout.min;
	            var diff = Date.now() - spinnerStartTime;
	            if (diff < timeout) {
	                timeout = timeout - diff;
	            }
	        }
	        clearTimeout(opacityTimeout);
	        if (timeout) {
	            opacityTimeout = setTimeout(function () {
	                _doDisableSpinner();
	                if (afterTimeout) {
	                    afterTimeout();
	                }
	            }, timeout);
	        } else {
	            _doDisableSpinner();
	        }
	    }
	};
	exports.default = Utils;

/***/ })

});


// WEBPACK FOOTER //
// blog-b7731c66a2cee4194866.js